import React, { useMemo } from "react";
import AdminTabelHeader from "../../components/layout/header/AdminTabelHeader";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { MaterialReactTable } from "material-react-table";
import axios from "axios";
import { BASEURL } from "../../../utils/BaseUrl";
import Swal from "sweetalert2";
import TraingleLoading from "../../../common/Loading/TraingleLoading";

const AdminFacilitiesTabel = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { data,isLoading } = useQuery({
    queryKey: "getallfacilities",
    queryFn: () =>
      axios.get(`${BASEURL}facilities`).then((res) => {
        return res?.data;
      }),
  });
  const reversedData = data?.sort((a, b) => b.id - a.id);
  const deltemutaion = useMutation({
    mutationFn: (id) => {
      return axios.delete(`${BASEURL}facilities/${id}`);
    },

    onSuccess: () => {
      Swal.fire({
        title: "Facilities Delted Successfully",
        icon: "success",
        draggable: false,
        // confirmButtonColor:"#fcd70c",
        customClass: {
          confirmButton: "custom-confirm-button", 
        },
      });
      queryClient.invalidateQueries({ queryKey: "getallfacilities" }); 
    },
  });

  const handleDelte = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then((result) => {
      if (result.isConfirmed) {
    
        deltemutaion.mutate(row);
      }
    });
  };
  const columns = useMemo(
    () => [
      {
        accessorFn: (row, index) => index + 1,
        id: "index",
        header: "S.No",
        size: 100,
      },
      {
        id: "image_url",
        header: "Image",
        Cell: ({ row }) => (
          <>
            <img
              src={row?.original?.image_url}
              alt="img"
              width={50}
              height={50}
            />
          </>
        ),
      },

      {
        accessorKey: "machine_type",
        header: "Machine Type",
        size: 300,
      },
      {
        accessorKey: "size",
        header: "Size",
      },

      {
        id: "actions",
        header: "Actions",
        Cell: ({ row }) => (
          <>
            <div className="flex items-center justify-around">
              <PencilIcon
                onClick={() => navigate(`edit/${row?.original?.id}`)}
                className="w-5 h-5 cursor-pointer mx-2"
              />

              <TrashIcon
                onClick={() => handleDelte(row?.original?.id)}
                className="w-5 h-5 cursor-pointer mx-2"
              />
            </div>
          </>
        ),
      },
    ],
    []
  );
  return (
    <div>
      {deltemutaion.isLoading && <TraingleLoading />}
      {
        isLoading && <TraingleLoading />
      }

      <AdminTabelHeader
        title={"Facilities"}
        btnStatus={true}
        btnname="Add"
        path="add"
      />
      <div className="p-4">
        <MaterialReactTable
          columns={columns}
          data={reversedData || []}
          enableColumnResizing
          enableColumnOrdering
        />
      </div>
    </div>
  );
};

export default AdminFacilitiesTabel;
